import { Modal } from 'antd';
import Upgrade from '../../../styles/images/upgradepop.svg';
import Styles from './scss/upgarde.module.scss'
import { navigateToTicketing } from '../../../base/utils';
import { GetItemFromStorage } from '../../../custom_hooks/useStorage';
import { LocalStorage } from '../../../custom_hooks/localStorageKeys';

function Internalupgrade({ onOk }:any) {
  
  const loginUserCcaasDetail = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);

  const close = () => {
    if(onOk){
      onOk()
    }
  }

  const open =()=>{
    navigateToTicketing()
  }

  return (
    <>
      <Modal
        title={<span></span>}
        open={true}
        className="customModal  skilldisable upgradeaichat"
        centered
        closeIcon={<span className="icon__Close16" ></span>}
        onCancel={close}
        footer={false}
      >
        <div className={Styles.upgradeimg}>
          <img src={Upgrade} alt='' />
        </div>
        {loginUserCcaasDetail?.roleid == 3
          ? <div className={Styles.growthplan}>
            <h3>Upgrade Your Plan and Unlock the Live Transcription</h3>
            {/* <button onClick={open}>Upgrade</button> */}
          </div>

          : <div className={Styles.growthplan}>
            <h3>Upgrade Required: Please contact your administrator to upgrade your plan and enable this feature</h3>
            <button onClick={close}>Close</button>
          </div>}
      </Modal>
    </>
  );
}
export default Internalupgrade;